import VueDragscroll from 'vue-dragscroll';
import { defineNuxtPlugin } from '#imports';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueDragscroll);
});
